module.exports = __webpack_public_path__ + "img/pc-help-5.29c9ab2c.jpg";